Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _to_array = require("@swc/helpers/_/_to_array");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var require_env = require('./env.cjs');
//#region src/logger.ts
var PREFIX = "[ Module Federation ]";
var DEFAULT_DELEGATE = console;
var LOGGER_STACK_SKIP_TOKENS = [
    "logger.ts",
    "logger.js",
    "captureStackTrace",
    "Logger.emit",
    "Logger.log",
    "Logger.info",
    "Logger.warn",
    "Logger.error",
    "Logger.debug"
];
function captureStackTrace() {
    try {
        var stack = /* @__PURE__ */ new Error().stack;
        if (!stack) return;
        var _stack_split = _to_array._(stack.split("\n")), rawLines = _stack_split.slice(1);
        var filtered = rawLines.filter((line)=>!LOGGER_STACK_SKIP_TOKENS.some((token)=>line.includes(token)));
        if (!filtered.length) return;
        return `Stack trace:\n${filtered.slice(0, 5).join("\n")}`;
    } catch  {
        return;
    }
}
var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger(prefix) {
        var delegate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_DELEGATE;
        _class_call_check._(this, Logger);
        this.prefix = prefix;
        this.delegate = delegate ?? DEFAULT_DELEGATE;
    }
    _create_class._(Logger, [
        {
            key: "setPrefix",
            value: function setPrefix(prefix) {
                this.prefix = prefix;
            }
        },
        {
            key: "setDelegate",
            value: function setDelegate(delegate) {
                this.delegate = delegate ?? DEFAULT_DELEGATE;
            }
        },
        {
            key: "emit",
            value: function emit(method, args) {
                var delegate = this.delegate;
                var stackTrace = require_env.isDebugMode() ? captureStackTrace() : void 0;
                var enrichedArgs = stackTrace ? _to_consumable_array._(args).concat([
                    stackTrace
                ]) : args;
                var order = (()=>{
                    switch(method){
                        case "log":
                            return [
                                "log",
                                "info"
                            ];
                        case "info":
                            return [
                                "info",
                                "log"
                            ];
                        case "warn":
                            return [
                                "warn",
                                "info",
                                "log"
                            ];
                        case "error":
                            return [
                                "error",
                                "warn",
                                "log"
                            ];
                        default:
                            return [
                                "debug",
                                "log"
                            ];
                    }
                })();
                for (var candidate of order){
                    var handler = delegate[candidate];
                    if (typeof handler === "function") {
                        var _handler;
                        (_handler = handler).call.apply(_handler, [
                            delegate,
                            this.prefix
                        ].concat(_to_consumable_array._(enrichedArgs)));
                        return;
                    }
                }
                for (var candidate1 of order){
                    var handler1 = DEFAULT_DELEGATE[candidate1];
                    if (typeof handler1 === "function") {
                        var _handler1;
                        (_handler1 = handler1).call.apply(_handler1, [
                            DEFAULT_DELEGATE,
                            this.prefix
                        ].concat(_to_consumable_array._(enrichedArgs)));
                        return;
                    }
                }
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("log", args);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("warn", args);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("error", args);
            }
        },
        {
            key: "success",
            value: function success() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("info", args);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("info", args);
            }
        },
        {
            key: "ready",
            value: function ready() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.emit("info", args);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (require_env.isDebugMode()) this.emit("debug", args);
            }
        }
    ]);
    return Logger;
}();
function createLogger(prefix) {
    return new Logger(prefix);
}
function createInfrastructureLogger(prefix) {
    var infrastructureLogger = new Logger(prefix);
    Object.defineProperty(infrastructureLogger, "__mf_infrastructure_logger__", {
        value: true,
        enumerable: false,
        configurable: false
    });
    return infrastructureLogger;
}
function bindLoggerToCompiler(loggerInstance, compiler, name) {
    if (!loggerInstance.__mf_infrastructure_logger__) return;
    if (!(compiler === null || compiler === void 0 ? void 0 : compiler.getInfrastructureLogger)) return;
    try {
        var infrastructureLogger = compiler.getInfrastructureLogger(name);
        if (infrastructureLogger && typeof infrastructureLogger === "object" && (typeof infrastructureLogger.log === "function" || typeof infrastructureLogger.info === "function" || typeof infrastructureLogger.warn === "function" || typeof infrastructureLogger.error === "function")) loggerInstance.setDelegate(infrastructureLogger);
    } catch  {
        loggerInstance.setDelegate(void 0);
    }
}
var logger = createLogger(PREFIX);
var infrastructureLogger = createInfrastructureLogger(PREFIX);
//#endregion
exports.bindLoggerToCompiler = bindLoggerToCompiler;
exports.createInfrastructureLogger = createInfrastructureLogger;
exports.createLogger = createLogger;
exports.infrastructureLogger = infrastructureLogger;
exports.logger = logger; //# sourceMappingURL=logger.cjs.map
